import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// UI框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 自定义样式
import './assets/style/base.less'

// 配置
import config from './config'
Vue.prototype.$config = config

// 指令
import authorize from './directive/authorize'
Vue.directive('authorize', authorize)

// 实例
new Vue({
  router,
	store,
  render: h => h(App)
}).$mount('#app')